import { Breadcrumb } from "antd";
import { Link } from "react-router";
import styled from "styled-components";

import { Palette } from "../../../../../core/styles/palette";

export const BreadcrumbStyle = styled(Breadcrumb)`
    &.aevi-breadcrumb {
        padding-top: 8px;
        padding-bottom: 16px;

        .ant-breadcrumb-separator {
            color: ${Palette.FormText};
        }
    }
`;

export const BreadcrumbLinkStyle = styled(Link)`
    color: ${Palette.FormText};
    text-decoration: none;

    &:hover {
        color: ${Palette.DarkGreen};
        text-decoration: underline;
    }
`;

export const BreadcrumbTextStyle = styled.span`
    color: ${Palette.FormText};
`;
